import { confirmFields } from '@/components/services/settingsSite/utils'

import render from './render'

export default function(options) {
  const component = confirmFields(options, [ 'sendername', 'senderUserId' ])

  return {
    ...component,

    render(h) {
      return render.call(this, h, options)
    }
  }
}
